export const getRecurlyHostedBillingInfoUrl = (token: string) =>
	`https://${process.env.RECURLY_SUBDOMAIN}.recurly.com/account/billing_info/edit?ht=${token}`;
